import { useState, useEffect, useRef, useCallback } from 'react';
import { BASE_WIDTH, BASE_HEIGHT } from '../constants/index.js';

const useTwitchExtension = () => {
    const [twitchId, setTwitchId] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const twitchContextRef = useRef(null);
    const twitchVideoResolutionRef = useRef(null);

    const setCssVarsForVideo = useCallback((width, height) => {
        const root = document.documentElement;

        root.style.setProperty('--video-width', `${width}px`);
        root.style.setProperty('--video-height', `${height}px`);

        const scaleX = width / BASE_WIDTH;
        const scaleY = height / BASE_HEIGHT;
        const scale = Math.min(scaleX, scaleY);
        root.style.setProperty('--video-scale', `${scale}`);

        const overlayScale = Math.min(1, scale);
        root.style.setProperty('--overlay-scale', `${overlayScale}`);
    }, []);

    useEffect(() => {
        if (window.Twitch && window.Twitch.ext) {
            const ext = window.Twitch.ext;

            ext.onAuthorized((auth) => {
                const channelId = auth.channelId || auth.userId;
                if (channelId) {
                    setTwitchId(channelId);
                }
                setIsConnected(true);
            });

            ext.onError(() => {
                setIsConnected(false);
            });

            ext.onContext((context) => {
                twitchContextRef.current = context;

                if (context.displayResolution) {
                    const [dw, dh] = String(context.displayResolution).split('x').map(Number);
                    if (dw && dh) {
                        setCssVarsForVideo(dw, dh);
                        return;
                    }
                }

                if (context.videoResolution) {
                    twitchVideoResolutionRef.current = context.videoResolution;
                    const [vw, vh] = String(context.videoResolution).split('x').map(Number);
                    if (vw && vh) {
                        setCssVarsForVideo(vw, vh);
                        return;
                    }
                }

                setCssVarsForVideo(window.innerWidth, window.innerHeight);
            });

            ext.actions.requestIdShare();
        }
    }, [setCssVarsForVideo]);

    return { twitchId, isConnected, twitchContextRef, twitchVideoResolutionRef };
};

export default useTwitchExtension;
